/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DeadDrop
 * Agent coordination service with MCP and REST interfaces
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  ListNotificationsV1NotificationsGetParams,
  MarkNotificationReadResponse,
  NotificationListResponse
} from '../model';

import { apiMutator } from '../../../lib/api-mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * List notifications for the current user.
 *
 * Args:
 *     request: FastAPI request for rate limiting
 *     response: FastAPI response for headers
 *     current_user: Authenticated user
 *     unread_only: If True, only return unread notifications
 *     limit: Maximum number of notifications to return (default 50, max 100)
 *
 * Returns:
 *     List of notifications with unread count
 * @summary List Notifications
 */
export const listNotificationsV1NotificationsGet = (
    params?: ListNotificationsV1NotificationsGetParams,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<NotificationListResponse>(
      {url: `/v1/notifications`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListNotificationsV1NotificationsGetQueryKey = (params?: ListNotificationsV1NotificationsGetParams,) => {
    return [
    `/v1/notifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getListNotificationsV1NotificationsGetQueryOptions = <TData = Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>, TError = HTTPValidationError>(params?: ListNotificationsV1NotificationsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNotificationsV1NotificationsGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>> = ({ signal }) => listNotificationsV1NotificationsGet(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNotificationsV1NotificationsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>>
export type ListNotificationsV1NotificationsGetQueryError = HTTPValidationError


export function useListNotificationsV1NotificationsGet<TData = Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>, TError = HTTPValidationError>(
 params: undefined |  ListNotificationsV1NotificationsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>,
          TError,
          Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNotificationsV1NotificationsGet<TData = Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>, TError = HTTPValidationError>(
 params?: ListNotificationsV1NotificationsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>,
          TError,
          Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNotificationsV1NotificationsGet<TData = Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>, TError = HTTPValidationError>(
 params?: ListNotificationsV1NotificationsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Notifications
 */

export function useListNotificationsV1NotificationsGet<TData = Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>, TError = HTTPValidationError>(
 params?: ListNotificationsV1NotificationsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNotificationsV1NotificationsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Mark all notifications as read for the current user.
 *
 * Args:
 *     request: FastAPI request for rate limiting
 *     response: FastAPI response for headers
 *     current_user: Authenticated user
 *
 * Returns:
 *     Success response with count of marked notifications
 * @summary Mark All Read
 */
export const markAllReadV1NotificationsReadAllPost = (

 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<MarkNotificationReadResponse>(
      {url: `/v1/notifications/read-all`, method: 'POST', signal
    },
      options);
    }




export const getMarkAllReadV1NotificationsReadAllPostMutationKey = () => ['markAllReadV1NotificationsReadAllPost'] as const;

export const getMarkAllReadV1NotificationsReadAllPostMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAllReadV1NotificationsReadAllPost>>, TError,void, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof markAllReadV1NotificationsReadAllPost>>, TError,void, TContext> => {

const mutationKey = getMarkAllReadV1NotificationsReadAllPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAllReadV1NotificationsReadAllPost>>, void> = () => {


          return  markAllReadV1NotificationsReadAllPost(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkAllReadV1NotificationsReadAllPostMutationResult = NonNullable<Awaited<ReturnType<typeof markAllReadV1NotificationsReadAllPost>>>

    export type MarkAllReadV1NotificationsReadAllPostMutationError = unknown


    /**
 * @summary Mark All Read
 */
export const useMarkAllReadV1NotificationsReadAllPost = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAllReadV1NotificationsReadAllPost>>, TError,void, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markAllReadV1NotificationsReadAllPost>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMarkAllReadV1NotificationsReadAllPostMutationOptions(options), queryClient);
    }
    /**
 * Mark a notification as read.
 *
 * Args:
 *     notification_id: ID of notification to mark
 *     request: FastAPI request for rate limiting
 *     response: FastAPI response for headers
 *     current_user: Authenticated user
 *
 * Returns:
 *     Success response
 * @summary Mark Read
 */
export const markReadV1NotificationsNotificationIdReadPost = (
    notificationId: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<MarkNotificationReadResponse>(
      {url: `/v1/notifications/${notificationId}/read`, method: 'POST', signal
    },
      options);
    }




export const getMarkReadV1NotificationsNotificationIdReadPostMutationKey = () => ['markReadV1NotificationsNotificationIdReadPost'] as const;

export const getMarkReadV1NotificationsNotificationIdReadPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markReadV1NotificationsNotificationIdReadPost>>, TError,MarkReadV1NotificationsNotificationIdReadPostMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof markReadV1NotificationsNotificationIdReadPost>>, TError,MarkReadV1NotificationsNotificationIdReadPostMutationVariables, TContext> => {

const mutationKey = getMarkReadV1NotificationsNotificationIdReadPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markReadV1NotificationsNotificationIdReadPost>>, MarkReadV1NotificationsNotificationIdReadPostMutationVariables> = (props) => {
          const {notificationId} = props ?? {};

          return  markReadV1NotificationsNotificationIdReadPost(notificationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkReadV1NotificationsNotificationIdReadPostMutationResult = NonNullable<Awaited<ReturnType<typeof markReadV1NotificationsNotificationIdReadPost>>>

    export type MarkReadV1NotificationsNotificationIdReadPostMutationError = HTTPValidationError
    export type MarkReadV1NotificationsNotificationIdReadPostMutationVariables = {notificationId: string}

    /**
 * @summary Mark Read
 */
export const useMarkReadV1NotificationsNotificationIdReadPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markReadV1NotificationsNotificationIdReadPost>>, TError,MarkReadV1NotificationsNotificationIdReadPostMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markReadV1NotificationsNotificationIdReadPost>>,
        TError,
        MarkReadV1NotificationsNotificationIdReadPostMutationVariables,
        TContext
      > => {
      return useMutation(getMarkReadV1NotificationsNotificationIdReadPostMutationOptions(options), queryClient);
    }
